// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1tP6a","label":"Radio_label__sMvyy","checkMark":"Radio_checkMark__1Wp4b","disabled":"Radio_disabled__3szqY"};